import { useEffect, useState } from "react";
import getApiEnvironment from "../../helpers/GetApiEnvironment";
import { fetchApi } from "@globalholdings/ui-common-functions";
import useFeatureFlag from "../../hooks/FeatureFlag";

const useKnowledgeOwl = ({ currentPermissions }) => {
  const [hasAccess, setHasAccess] = useState(false);

  const { flagStatus } = useFeatureFlag({
    flagName: "ShowKnowledgeOwlWidget&appName=CompanyWebsite",
  });

  const fetchKOToken = async () => {
    try {
      const res = await fetchApi(
        "GET",
        `${getApiEnvironment()}.gateway.ghllc.com/auth/knowledgeowl/StandaloneAuth`
      );

      return res.data.koAuthToken;
    } catch (error) {
      return null;
    }
  };

  const authenticateKnowledgeOwl = async () => {
    try {
      const accessToken = await fetchKOToken();
      if (!accessToken) return;

      var authToken = { type: "oauth", token: accessToken };

      _ko19.authenticate(authToken);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const toggleButton = () => {
    if (!window._ko19) return;

    window._ko19.open();
  };

  useEffect(() => {
    if (currentPermissions.length) {
      const hasAccess = currentPermissions.find(
        (p) => p.component === "UI.KO.Access" && p.accessLevel === "R"
      );
      
      if (hasAccess && flagStatus) {
        authenticateKnowledgeOwl();
      }

      setHasAccess(hasAccess);
    }
  }, [currentPermissions.length, flagStatus]);

  return { hasAccess, toggleButton };
};

export const useUpdateRecommended = () => {
     const path = window.location.pathname;
     const segment1 = path.split('/')[1];

     useEffect(() => {
        const callUpdateRecommended = () => {
          var _ko19 = window._ko19;
          if (!_ko19 || typeof _ko19.updateRecommended !== 'function') return false;

          switch (segment1) {
             case "favorites":
               _ko19.updateRecommended('/Dashboard/Favorites');
               break;
             case "clients":
               _ko19.updateRecommended('/Dashboard/Clients');
               break;
             case "deposits":
               _ko19.updateRecommended('/Dashboard/Deposits');
               break;
             case "payments":
               _ko19.updateRecommended('/Dashboard/Payments');
               break;
             case "withdrawals":
               _ko19.updateRecommended('/Dashboard/Withdrawals');
               break;
             default:
               break;
           }
           return true;
        };

        if (callUpdateRecommended()) return;

        const interval = setInterval(() => {
          if (callUpdateRecommended()) {
            clearInterval(interval);
          }
        }, 500);

        return () => clearInterval(interval);
     }, [path])
}

export default useKnowledgeOwl;
